// removed by extract-text-webpack-plugin
module.exports = {"BreadBottom":"BurgerIngrediants_BreadBottom_BNN39","BreadTop":"BurgerIngrediants_BreadTop_3LsZA","Seeds1":"BurgerIngrediants_Seeds1_1dyJT","Seeds2":"BurgerIngrediants_Seeds2_VMksU","Meat":"BurgerIngrediants_Meat_2qMgN","Cheese":"BurgerIngrediants_Cheese_zGY1w","Salad":"BurgerIngrediants_Salad_2cyrm","Bacon":"BurgerIngrediants_Bacon_31foR"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Burger/BurgerIngrediants/BurgerIngrediants.css
// module id = 107
// module chunks = 3